import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaAddress = yup.object().shape({
  cep: yup.string().required(translate('addressModal.validation.cepRequired')),
  address: yup
    .string()
    .required(translate('addressModal.validation.streetRequired')),
  neighborhood: yup
    .string()
    .required(translate('addressModal.validation.neighborhoodRequired')),
  city: yup
    .string()
    .required(translate('addressModal.validation.cityRequired')),
  state: yup
    .string()
    .required(translate('addressModal.validation.stateRequired')),
});
